<template>
  <Authenticator class="my-2">
    <div class="md my-2">
      <div class="row px-3 py-2 my-0">
        <h1>Badges</h1>
        <p>Provide recognition for achievements and behaviour in your organisation.</p>
        <div class="btn-group d-flex w-100">
          <div class="mb-2 mt-0 w-100">
            <router-link :to="'/badges/user/'+viewer_email">
              <button type="button"
                      class="btn btn-outline-light w-100">
                View my badges
              </button>
            </router-link>
          </div>
        </div>
      </div>
      <div class="row px-3 mt-2">
        <h2>View badges</h2>
        <form class="mb-3"
              @submit.prevent="view_badges">
          <input class="form-control w-100"
                  data-bs-theme="dark"
                  name="target_email"
                  :placeholder="'...@'+organisation"
                  required />
          <div class="btn-group d-flex w-100 my-1">
            <button type="submit"
                    class="btn btn-outline-light"
                    data-bs-theme="dark">
              View badges
            </button>
          </div>
        </form>
      </div>
      <div class="row mx-3 mt-2">
        <div v-if="view_badge_error"
              class="alert alert-warning"
              role="alert"
              data-bs-theme="dark">
          {{ view_badge_error }}
        </div>
      </div>
      <div class="row px-3">
        <h2>Award a badge</h2>
        <div class="btn-group d-flex w-100">
          <div class="mb-3 mt-0 w-100">
            <router-link to='/badges/award'>
              <button type="button"
                      class="btn btn-outline-light w-100">
                Award a badge
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </Authenticator>
</template>

<script>
  import Authenticator from '@/authenticator/authenticator.js'
  import { get_email, post_user } from '@/backend/backend.js'
  import { get_valid_email } from '@/badges/badges.js'

  export default {
    components: {
      Authenticator
    },
    data() {
      return {
        viewer_email: null,
        view_badge_error: null,
      }
    },
    created() {
       document.title = "Badges"
    },
    mounted() {
      get_email().then(
        email => {this.viewer_email = email}
      )
      post_user()
    },
    methods: {
      view_badges(submit_event) {
        var data = new FormData(submit_event.target)
        var data_object = {}
        data.forEach((value, key) => {
          data_object[key] = value
        })

        var target_email = get_valid_email(data_object.target_email)
        if (!target_email) {
          this.view_badge_error = "Email is not valid."
          return
        }

        var target_organisation = target_email.split('@')[1]
        if (target_organisation != this.organisation) {
          this.view_badge_error = "You can only view badges from your own organisation (...@" + this.organisation + ")."
          return
        }

        // eslint-disable-next-line
        this.$router.push('/badges/user/'+target_email)
        this.$forceUpdate()
      }
    },
    computed: {
      organisation() {
        if (!this.viewer_email) { return null }
        return this.viewer_email.split('@')[1]
      }
    }
  }
</script>

<style scoped>
  .md {
    text-align: left;
    background-color: rgb(43, 43, 43);
    border-radius: 10px;
  }
</style>
